import { ADD_JOB_NOTE } from '../../../constants';

const initialState = {
  data: null,
  loading: false,
  error: {},
};

export default function (state = initialState, { type, payload } = {}) {
  switch (type) {
    case ADD_JOB_NOTE.LOAD:
      return {
        ...state,
        loading: true,
      };
    case ADD_JOB_NOTE.SUCCESS:
      return {
        ...state,
        data: payload,
        loading: false,
      };
    case ADD_JOB_NOTE.FAIL:
      return {
        ...state,
        error: payload,
        loading: false,
      };
    default:
      return state;
  }
}
